import { render, staticRenderFns } from "./popCategoryAdd.vue?vue&type=template&id=a7237382&scoped=true&"
import script from "./popCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./popCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./popCategoryAdd.vue?vue&type=style&index=0&id=a7237382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7237382",
  null
  
)

export default component.exports